<template>
	<div id='' v-loading='loading' style='min-width: 950px;' class='gPageBorder'>
		<tyc :tqobj='tqobj'></tyc>




		<!-- <div v-for="item in vsinfos" >
      <el-popover
        placement="bottom"
        width="120"
        trigger="click"
        v-model="item.ispop">
        <el-button slot='reference' type='text'>
          <i class='el-icon-setting' style="margin-left: 5px;"></i>
        </el-button>
        <div style="margin-bottom: 10px">
          <el-checkbox v-model="item.p1">备选项</el-checkbox>
        </div>
        <div style="margin-bottom: 10px">
          <el-checkbox v-model="item.p2">备选项1</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="item.p3">备选项</el-checkbox>
        </div>
      </el-popover>
    </div> -->

		<el-dialog class='gDia' :title="$t('app_chooseFile')" v-model="isSelectFile" @open=open @close='fclose' size=''>
			<div id='' class='gBorder'>


				<el-row style=''>
					<el-col :span="5">
						<div class='gSgLeftBtn' style="padding-left:8px;">
							<el-input :placeholder="$t('app_name')" icon='search' :on-icon-click='tquery'
								@keyup.enter.native='tquery' v-model='tqueryKey'></el-input>
						</div>
					</el-col>
					<!-- <el-col v-show='true' :offset="0" :span="5">

            <div class='gCtrl'>
              <MechanismSelector style='width:100%;' :data="mechanismData" ></MechanismSelector>
            </div>
          </el-col> -->

				</el-row>

				<el-table class='gTopMg' ref="multipleTable" id='dpTable' :data="tableData" border tooltip-effect="dark"
					style="width: 100%" @selection-change="handleSelectionChange1">
					<!-- <el-table-column

            type="selection"
            align='center'
            width="55">
          </el-table-column> -->
					<el-table-column prop="fileName" align='center' :label="$t('app_filename')" width="150">
					</el-table-column>
					<el-table-column align='center' prop="fileVersion" :label="$t('app_version')" width="150">
					</el-table-column>
					<el-table-column align='center' :formatter="setType" :label="$t('app_filetype')" width="150">
					</el-table-column>
					<el-table-column :formatter="setSType" align='center' :label="$t('app_subtype')" width='150'>
					</el-table-column>
					<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width='150'>
					</el-table-column>

					<el-table-column prop="operate" :label="$t('app_operate')" align='center' width='106'>
						<template slot-scope='scope'>



							<el-tooltip v-show="true" class="item" effect="dark" :content="$t('app_choose')"
								placement="top">
								<el-button @click='selected(scope.row)' type=text><i class="fa fa-check"
										style=""></i></el-button>
							</el-tooltip>


							<!-- <el-tooltip class="item" effect="dark" :content="dfDelCt" placement="top">
                <el-button v-show="true"  @click='delAppPush(scope.row)' type=text><i class="fa fa-trash" style="color:#FF4949;"></i></el-button>
              </el-tooltip> -->

						</template>
					</el-table-column>
				</el-table>

				<div class="gPgDiv">

					<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized"
						:current-page="page" :page-sizes='$gRows' :page-size="$gRow"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<el-dialog class='gDia' :title="$t('app_chooseFile')" v-model="isSelectFile1" @open=open @close='fclose'
			size=''>
			<div id='' class='gBorder'>

				<el-row style=''>
					<el-col :span="5">
						<div class='gSgLeftBtn' style="padding-left:8px;">
							<el-input :placeholder="$t('app_name')" icon='search' :on-icon-click='tquery1'
								@keyup.enter.native='tquery1' v-model='tqueryKey'></el-input>
						</div>
					</el-col>

				</el-row>

				<el-table class='gTopMg' ref="multipleTable" id='dpTable' :data="lcdata" border tooltip-effect="dark"
					style="width: 100%" @selection-change="handleSelectionChange1">
					<el-table-column prop="launchername" align='center' :label="$t('app_filename')" width="150">
					</el-table-column>
					<el-table-column align='center' prop="version" :label="$t('app_version')" width="150">
					</el-table-column>
					<!-- <el-table-column
            align='center'
            :formatter="setType"
            :label="$t('app_filetype')"
            width="150">
          </el-table-column> -->
					<!-- <el-table-column
            :formatter="setSType"
            align='center'
            :label="$t('app_subtype')"
            width='150'>
          </el-table-column> -->
					<el-table-column align='center' prop="distrabutorname" :label="$t('app_distributor')" width='150'>
					</el-table-column>

					<el-table-column prop="operate" :label="$t('app_operate')" align='center' width='106'>
						<template slot-scope='scope'>

							<el-tooltip v-show="true" class="item" effect="dark" :content="$t('app_choose')"
								placement="top">
								<el-button @click='selected1(scope.row)' type=text><i class="fa fa-check"
										style=""></i></el-button>
							</el-tooltip>

							<!-- <el-tooltip class="item" effect="dark" :content="dfDelCt" placement="top">
                <el-button v-show="true"  @click='delAppPush(scope.row)' type=text><i class="fa fa-trash" style="color:#FF4949;"></i></el-button>
              </el-tooltip> -->

						</template>
					</el-table-column>
				</el-table>

				<div class="gPgDiv">

					<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized"
						:current-page="page" :page-sizes='$gRows' :page-size="$gRow"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>


		<el-form class='gForm' label-position="right" ref="form" :rules='rules' label-width="12.5%" :model='form'>


			<el-form-item :label="$t('app_taskName')" prop="tname">
				<el-input :placeholder="$t('app_input')" v-model="form.tname"></el-input>
			</el-form-item>

			<el-form-item :label="$t('lin_global.label_type')" prop='dtype'>
				<el-radio-group v-model="form.dtype" @input="change_device">
					<el-radio :label="1">{{ $t('lin_global.device_type_1') }}</el-radio>
					<el-radio :label="2">{{ $t('lin_global.device_type_2') }}</el-radio>
				</el-radio-group>
			</el-form-item>



			<!-- <el-input style="position:absolute;width:0;height:0;opacity:0;"></el-input> -->

			<div id='ptEditFr'>
				<div class='pteditdiv' v-for='item,index in ulData'>


					<div class='ptedlinecm'>

						<img @click='delrow(index)'
							style="cursor: pointer;position:absolute;width: 16px;height: 16px;left: 0;"
							:src='delicon' />

						<!-- <div @click='delrow(index)' style="cursor: pointer;position:absolute;width: 16px;height: 16px;color:#20A0FF;background: #CBE5FF;border-radius: 3px;">
              <i style="position:absolute;left: 5px; top: 5px;font-size: 6px;" class="el-icon-close"></i>
            </div> -->


						{{$t('app_subtask')}}{{index + 1}}

					</div>
					<div class='ptedlinecm'>
						<label>{{$t('app_sltstype')}}</label>&nbsp;&nbsp;
						<el-select v-model="item.taskType" @change="taskChange(index,item)"
							:placeholder="$t('app_type')">
							<el-option v-for="item in tasktypes" :key="item.type" :label="item.name" :value="item.type">
							</el-option>
						</el-select>
					</div>
					<div class='ptedlinecm' style="">
						<i style="line-height:55px;" v-show="item.taskType != '9' && item.content"
							class="el-icon-circle-check"></i>
						<label>{{item.taskType == '9'? $t('app_command') : $t('app_chooseFile')}}</label>&nbsp;&nbsp;

						<!-- fcda -->
						<el-select style="width: 48%;" @change="commChange(index,item)" v-show="item.taskType == '9'"
							v-model="item.content" :placeholder="$t('app_type')">
							<el-option v-for="item in comms" :key="item.vl" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>&nbsp;&nbsp;

						<el-tooltip class="item" effect="dark" :content="item.file" placement="top">
							<el-button style="max-width:55%;text-overflow: ellipsis;overflow:hidden;"
								v-show="item.taskType != '9'" type='text'
								@click="slFile(index,item.taskType)">{{item.file}}</el-button>
						</el-tooltip>

						<el-tooltip v-show="(item.content == 'XZYY' && !item.p2) || (item.content == 'ZQ' && !item.p1)"
							class="item" effect="dark" :content="item.file" placement="top"> <!-- xzyy1 -->
							<el-button
								style="right:0;max-width:43%;text-overflow: ellipsis;overflow:hidden;position:absolute;line-height:55px;"
								type='text' @click="slFile(index,item.taskType)">{{item.file}}</el-button>
						</el-tooltip>

						<el-input v-show="(item.content=='XZYY'&&item.p2)||(item.content=='ZQ'&&item.p1)"
							v-model='item.fileId' :placeholder="$t('app_ippkgname')"
							style="width: 36%;display:inline-block;"></el-input>
					</div>

					<div class='ptedlinecm' style="">
						<i @click='sortEv(true, index, item)' class="el-icon-caret-top"></i>
						<i @click='sortEv(false, index, item)' class="el-icon-caret-bottom"></i>
					</div>

					<div v-show='isPop(item.taskType, item.content)' class='ptedlinecm' style="">
						<el-popover placement="bottom" width="200" style="" trigger="click" v-model="item.ispop">
							<el-button slot='reference' type='text'>
								<i class='el-icon-setting' style="margin-left: 5px;"></i>
							</el-button>
							<div v-for='title,pindex in getPopMenu(item.taskType, item.content)'
								:style="getPopCss(pindex,item.taskType,item.content)">
								<el-checkbox @change="paramChange(pindex+1,index)"
									v-model="item['p'+(pindex+1)]">{{title}}</el-checkbox>
							</div>
						</el-popover>
					</div>
				</div>
			</div>

			<div id='ptAddTask' @click='addTask'>
				+{{$t('app_addsubts')}}
			</div>

			<!-- <el-form-item :label="$t('app_file')" prop='fileId'>
        <el-button @click="isSelectFile = true" type='primary'>{{$t('app_chooseFile')}}</el-button>
        <p>{{form.file.fileName}}</p>
      </el-form-item>  -->

			<!-- <el-form-item v-show='form.file.fileType == 1 || form.file.fileType == 5 || form.file.fileType == 7' :label="$t('app_fileinsst')" prop=''>
        <el-checkbox v-show='form.file.fileType == 7' v-model="form.open">{{$t('app_autoscopen')}}</el-checkbox>
        <el-checkbox v-show='form.file.fileType == 1 || form.file.fileType == 5' v-model="form.tip">{{$t('app_psscandtip')}}</el-checkbox>
      </el-form-item> -->

			<el-form-item>
				<el-button type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
				<el-button type='primary' style='' @click="save('form')">{{$t('app_save')}}</el-button>
			</el-form-item>
		</el-form>

	</div>
</template>

<style>
	#ptEditFr {
		width: 100%;
		margin-bottom: 20px;
	}

	.pteditdiv {
		width: 100%;
		height: 70px;
		margin-bottom: 20px;
		border-radius: 5px;
		background: rgb(233, 244, 254);
		border: 1px solid rgb(214, 234, 254);
		overflow: hidden;
	}

	.ptedlinecm {
		float: left;
		line-height: 70px;
		display: inline-block;
		overflow: hidden;
		position: relative;
		text-overflow: ellipsis;
	}

	.ptedlinecm:nth-child(1) {
		width: 12%;
		height: 100%;
		color: #409EFF;
		font-size: 21px;
		padding-right: 15px;
		text-align: right;
		line-height: 70px;
	}

	.ptedlinecm:nth-child(2) {
		padding-left: 15px;
	}

	.ptedlinecm:nth-child(3) {
		width: 38.333%;
		padding-left: 40px;
		/* background: greenyellow; */
		position: relative;
	}

	.ptedlinecm:nth-child(3) .el-icon-circle-check {
		position: absolute;
		color: #67C23A;
		right: 0;
		top: 10px;
	}



	.ptedlinecm:nth-child(4) {
		width: 50px;
		float: right;
		height: 100%;
	}

	.ptedlinecm:nth-child(4) i {
		width: 100%;
		height: 15px;
		font-size: 15px;
		text-align: center;
		line-height: 15px;
		display: block;
		color: rgb(74, 153, 250);
		cursor: pointer;
	}

	.ptedlinecm:nth-child(4) i:nth-child(1) {
		margin-top: 20px;
	}

	.ptedlinecm:nth-child(5) {
		width: 30px;
		float: right;
		height: 100%;
	}



	#ptAddTask {
		text-align: center;
		border: 1px dashed lightgrey;
		margin-bottom: 20px;
		height: 35px;
		color: rgb(166, 167, 166);
		line-height: 35px;
		cursor: pointer;
	}
</style>

<script>
	import tyc from '@/components/global/tyc'
	import jq from 'jquery'
	import delsvg from "@/assets/images/taskdel.svg"
	export default {
		data() {
			var phoneCheck = (rule, value, callback) => {
				if (!this.isLegalMobile(value)) {
					callback(new Error(this.$t('app_phoneIllegal')));
				} else {
					callback()
				}
			}
			return {
				mode: 0,
				delicon: delsvg,
				vsinfos: [{
						ispop: false,
						p1: false,
						p2: false,
						p3: false
					},
					{
						ispop: false,
						p1: false,
						p2: false,
						p3: false
					}
				],
				tid: '',
				info: '',
				loading: false,
				finalUl: '',
				ulData: [{
					taskType: '',
					content: '',
					fileId: '',
					file: this.$t('app_file'),
					tmptype: '',
					tmpct: '',
					p1: false,
					p2: false,
					p3: false
				}],
				tasktypes: [],
				lcdata: [],
				comms: [],
				tqobj: '',
				tqueryKey: '',
				ftypes: '',
				ttypes_1: '',
				ttypes_2: '',
				getftype: '',
				getstype: '',
				typeVl: '',
				page: 1,
				total: 0,
				tableData: [],
				slFileIndex: -1,
				isSelectFile: false,
				isSelectFile1: false,
				fatherList: [],
				form: {
					tname: '',
					dtype: 1,
				},
				rules: {
					tname: [{
						required: true,
						message: this.$t('app_inputName'),
						trigger: 'blur'
					}],
					fileId: [{
						required: true,
						message: this.$t('app_chooseFile'),
						trigger: 'blur'
					}]
					// tel: [
					//   { required: true, message: this.$t('app_inputTruePhone'), trigger: 'blur'/*, validator: phoneCheck*/}
					// ]
				}
			}
		},
		components: {
			tyc
		},
		computed: {

		},
		methods: {
			change_device(data) {
				if (data == 1) {
					this.tasktypes = this.ttypes_1;
				} else {
					this.tasktypes = this.ttypes_2;
				}
				this.$nextTick(() => {
					this.ulData = [{
						taskType: '',
						content: '',
						fileId: '',
						file: this.$t('app_file'),
						tmptype: '',
						tmpct: '',
						p1: false,
						p2: false,
						p3: false
					}];
				})


			},
			getLc() {
				var distributorId = ''
				var orderName = ''
				var orderType = ''
				this.$launcherList(this.page, this.$gRow, this.tqueryKey, distributorId, orderName, orderType, '2',
					res => {
						this.lcdata = res.data
					}, '')
			},
			paramChange(pindex, index) {
				var item = this.ulData[index]
				if (item.content == 'XZYY' && pindex == 2) {
					item.fileId = ''
					if (item.p2) {
						item.file = ''
					} else {
						item.file = this.$t('app_file')
					}
				} else if (item.content == 'ZQ') {
					item.fileId = ''
					item.file = this.$t('app_file')
				}
				this.$set(this.ulData, index, item)
			},
			commChange(index, item) {
				// console.log('comm change', index, item)
				if (item.taskType == 9 && (item.content != item.tmpct)) {
					this.ulData[index].file = this.$t('app_file')
					this.ulData[index].fileId = ''
					this.ulData[index].p1 = false
					this.ulData[index].p2 = false
					this.ulData[index].p3 = false
					this.ulData[index].tmpct = item.content
				}

			},
			getPopCss(index, type, ct) {
				var css = ''
				if (index < 2 && this.getPopMenu(type, ct).length != 1) {
					return 'margin-bottom: 10px;' + css
				} else {
					return 'margin-bottom: 0px;' + css
				}
			},
			getPopMenu(type, ct) {
				var type1 = [
					this.$t('app_tipud')
				]
				var type2 = [
					this.$t('app_tipud'),
					this.$t('app_autorun'),
					this.$t('app_cusins')
				]
				var type3 = [
					this.$t('app_appuninstall'),
					this.$t('app_ippkgname')
				]
				var type4 = [
					this.$t('app_forcerun')
				]
				var type5 = [
					this.$t('app_ippkgname')
				]
				switch (type + '') {
					case '1':
					case '2':
					case '5':
						return type1
					case '7':
						return type2
					case '9':
						if (ct == 'XZYY') {
							return type3
						} else if (ct == 'ZQ') {
							return type5
						} else return type4
				}

			},
			isPop(type, ct) {
				switch (type + '') {
					case '1':
					case '2':
					case '5':
					case '7':
						return true
					case '9':
						if (ct == 'XZYY' || ct == 'HFCCSZ' || ct == 'ZQ')
							return true
						else return false
					default:
						return false
				}
			},
			fclose() {
				this.tqueryKey = ''
				this.page = 1
			},
			delrow(index) {
				if (this.ulData.length != 1) {
					this.ulData.splice(index, 1)
				} else {
					this.$message(this.$t('lin_global.notNull'))
				}
			},
			getDetail() {
				this.loading = 1
				this.$pTaskEdit(this.tid, (res) => {
					this.loading = 0
					if (res.status === 200) {
						// 编辑
						if (res.data.subTask[0].taskType == "12" || res.data.subTask[0].taskType == "6") {
							this.form.dtype = 2
							this.tasktypes = this.ttypes_2
						} else {
							this.form.dtype = 1
							this.tasktypes = this.ttypes_1
						}
						this.info = res.data
						this.form.tname = res.data.taskName
						var arr = []
						res.data.subTask.forEach(vl => {
							var p1 = false,
								p2 = false,
								p3 = false
							var tmpar = []
							switch (vl.taskType) {
								case '1':
								case '2':
								case '5':
									p1 = vl.installType == '0' ? true : false
									break
								case '7':
									tmpar = vl.installType.split('-')
									if (tmpar.length == 3) {
										p1 = tmpar[0] == '0' ? true : false
										p2 = tmpar[1] == '1' ? true : false
										p3 = tmpar[2] == '1' ? true : false
									}
									break
								case '9':
									if (vl.content == 'XZYY') {
										tmpar = vl.installType.split('-')
										if (tmpar.length == 2) {
											p2 = tmpar[0] == '1' ? true : false
											p1 = tmpar[1] == '3' ? true : false
										}
										// p1 = vl.installType == '3'? true:false
									} else if (vl.content == 'HFCCSZ') {
										p1 = vl.installType == '5' ? true : false
									} else if (vl.content == 'ZQ') {
										p1 = vl.installType == '0' ? false : true
									}
									break
							}
							arr.push({
								taskType: vl.taskType,
								content: vl.content,
								fileId: vl.fileId,
								file: vl.fileName,
								tmptype: vl.taskType,
								tmpct: vl.content,
								p1: p1,
								p2: p2,
								p3: p3
							})
						})
						this.ulData = arr
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = 0
				})
			},
			checkUlData() {
				var existnull = false
				var arr = []
				this.ulData.forEach((vl, index) => {
					if (!vl.taskType || !vl.content) {
						existnull = true
					} else if ((vl.content == 'XZYY' || vl.content == 'ZQ') && !vl.fileId) {
						existnull = true
					}
					//// make param
					var instype = ''
					switch (vl.taskType + '') {
						case '1':
						case '2':
						case '5':
							instype = vl.p1 ? '0' : '1'
							break
						case '7':
							instype = (vl.p1 ? '0' : '1') + '-' + (vl.p2 ? '1' : '0') + '-' + (vl.p3 ? '1' : '0')
							break
						case '9':
							if (vl.content == 'XZYY') {
								instype = vl.p1 ? '3' : '2'
								instype = vl.p2 ? '1-' + instype : '0-' + instype
								// 选择应用-普通应用 0-2，
								// 选择应用-客制化应用 0-3，
								// 输入包名-普通应用 1-2，
								// 输入包名-客制化应用 1-3，
							} else if (vl.content == 'HFCCSZ') {
								instype = vl.p1 ? '5' : '4'
							} else if (vl.content == 'ZQ') {
								instype = vl.p1 ? '1' : '0'
							} else instype = ''
							break
						default:
							instype = ''
							break
					}
					arr.push({
						num: index + 1,
						taskType: vl.taskType,
						content: vl.content,
						fileId: vl.fileId,
						installType: instype
					})
				})
				if (!existnull) {
					this.finalUl = arr
				}
				return !existnull
			},
			addTask() {
				this.ulData.push({
					taskType: '',
					content: '',
					fileId: '',
					file: this.$t('app_file'),
					tmptype: '',
					tmpct: '',
					p1: false,
					p2: false,
					p3: false
				})
			},
			sortEv(isUp, index, item) {
				if (isUp && index != 0) {
					// up
					var obj = this.ulData[index - 1]
					this.$set(this.ulData, index - 1, item)
					this.$set(this.ulData, index, obj)
				} else if (!isUp && index < this.ulData.length - 1) {
					// down
					var obj = this.ulData[index + 1]
					this.$set(this.ulData, index + 1, item)
					this.$set(this.ulData, index, obj)
				} else {

					this.$message(this.$t('app_inbdside'))
				}
			},
			slFile(index, type) {
				console.log(index, type)
				this.slFileIndex = index
				this.typeVl = type
				var item = this.ulData[index]
				if (type) {
					if (item.content == 'ZQ') {
						this.isSelectFile1 = true
						this.getLc()
					} else
						this.getList(true)
				} else {
					this.$message(this.$t('app_plsltype'))
				}
			},
			taskChange(index, item) {

				if (item.taskType != item.tmptype) {
					this.ulData[index].file = this.$t('app_file')
					this.ulData[index].content = ''
					this.ulData[index].fileId = ''
					this.ulData[index].p1 = false
					this.ulData[index].p2 = false
					this.ulData[index].p3 = false
					this.ulData[index].tmptype = item.taskType
				}

			},
			isRepeatData(row) {
				var isrp = false
				var rowtype = this.ulData[this.slFileIndex].taskType
				this.ulData.forEach(item => {
					var rfid = ''
					if (item.content == 'XZYY' || item.content == 'ZQ') {
						rfid = item.fileId
					} else {
						rfid = item.content
					}
					var fid = item.content == 'ZQ' ? row.launcherid : row.fileId
					if (rfid == fid && (rowtype == item.taskType)) {
						isrp = true
						return
					}
				})
				return isrp
			},
			selected(row) {
				console.log(row)
				// this.form.file = row
				// this.form.fileId = row.fileId
				if (this.ulData[0].taskType == "12" || this.ulData[0].taskType == "6") {
					this.form.dtype = 2
					this.tasktypes = this.ttypes_2
				} else {
					this.form.dtype = 1
					this.tasktypes = this.ttypes_1
				}
				if (this.isRepeatData(row)) {
					this.$message(this.$t('app_flexist'))
					return
				}

				var item = this.ulData[this.slFileIndex]
				if (item.content == 'XZYY') {
					item.fileId = row.fileId
				} else {
					item.content = row.fileId
				}
				item.file = row.fileName
				this.$set(this.ulData, this.slFileIndex, item)

				this.isSelectFile = false
				this.fclose()
				this.rblur()
			},
			selected1(row) {

				if (this.isRepeatData(row)) {
					this.$message(this.$t('app_flexist'))
					return
				}

				var item = this.ulData[this.slFileIndex]
				item.fileId = row.launcherid
				item.file = row.launchername
				this.$set(this.ulData, this.slFileIndex, item)
				this.isSelectFile1 = false
				this.fclose()
				this.rblur()
			},
			tquery() {
				this.getList()
			},
			tquery1() {
				this.getLc()
			},
			setType(row) {
				return this.getftype[row.fileType]
			},
			setSType(row) {
				return this.getstype[row.subFileType]
			},
			pageSelect(page) {
				this.page = page
				this.getList()
			},
			pageSized(size) {
				this.$gRow = size
				this.getList()
			},
			getList(isShow) {
				this.loading = 1
				var name = this.tqueryKey
				var mcid = ''
				var ftype = this.typeVl == 9 ? '7' : this.typeVl
				this.$pTaskPushList(this.page, this.$gRow, name, mcid, ftype, '', (res) => {
					this.loading = 0

					if (res.status == 200) {
						this.tableData = res.data
						this.total = res.total

						if (isShow) {
							this.isSelectFile = true
						}
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = 0
				})
			},
			isLegalMobile(tel) {
				var sMobile = tel
				var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
				var re = new RegExp(regex, 'g')
				if (!(re.test(sMobile))) {
					return false
				} else {
					return true
				}
			},
			newform() {

				this.loading = 1
				// var open = this.form.open? '1':'0'
				// var tip = this.form.tip? '1':'0'
				this.$pTaskAddTask(this.form.tname, this.finalUl, (res) => {
					this.loading = 0
					if (res.status === 200) {
						// this.$router.go(-1)
						if (res.data) {
							this.$router.push({
								path: '/task/ptask/detail',
								query: {
									fid: res.data.fileId,
									tid: res.data.taskId,
									tty: res.data.taskType,
									showdv: 1
								}
							})
						}
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			editform() {
				this.loading = 1
				this.$pTaskEditTask(this.tid, this.form.tname, this.finalUl, (res) => {
					this.loading = 0
					if (res.status === 200) {
						this.$router.go(-1)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			rblur() {
				this.$refs['form'].validate((valid) => {
					if (valid) {

					} else {
						return false
					}
				})
			},
			save(name) {

				if (!this.checkUlData()) {
					this.$message(this.$t('app_inputCp'))
					return
				}

				// console.log(this.finalUl)
				// return

				this.$refs[name].validate((valid) => {
					if (valid) {
						// if (this.config.type === 0) {
						//   this.newform()
						// } else {
						//   this.editform()
						// }

						if (this.tid) {
							this.editform()
						} else {
							this.newform()
						}
					} else {
						return false
					}
				})
			},
			cancel() {
				this.$router.go(-1)
			}
		},
		mounted() {
			var wcomm = this.$getWObj().login.userType == 0 ? 'comms1' : 'comms'
			this.tqobj = {
				keys: ['ftypes', 'ftype', 'sftype', 'taskTypeArr1', wcomm, 'taskTypeArr1_1', 'taskTypeArr1_2'],
				callback: data => {
					console.log(data)
					this.ftypes = data[0]
					this.getftype = data[1]
					this.getstype = data[2]
					// this.tasktypes = data[3].slice(1, data[3].length)
					this.comms = data[4]
					this.tasktypes = data[5] // 默认第一种
					this.ttypes_1 = data[5]
					this.ttypes_2 = data[6]
				}
			}
			/////////// mode 0=new 1=edit 2=push
			this.mode = this.$route.query.mode
			this.tid = this.$route.query.tid
			switch (this.mode) {
				case 2:
					//// tag tag
					// ({taskType: '', content: '', fileId: '', file: this.$t('app_file'), tmptype: '', tmpct: '', p1: false, p2: false, p3: false})
					///// 翻译
					var cftype = this.$route.query.ftype
					if (cftype == '9') {
						cftype = '10'
					} else if (cftype == '10') {
						cftype = '11'
					}else if(cftype == '11'){
						cftype = '12'
					}
					this.ulData[0].taskType = cftype
					this.slFileIndex = 0
					this.form.tname = this.$route.query.fname
					this.$pTaskPushList(1, 10, '', '', '', this.$route.query.fid, (res) => {
						if (res.data.length == 1) {
							this.selected(res.data[0])
						}
					}, '')
					break
				default:
					if (this.tid) {
						this.getDetail()
					}
			}
			// this.getList()
		}
	}
</script>


// WEBPACK FOOTER //
// edit.vue?19176d41